export type PresetDefaultsData = {
  attributeMapping?: Record<string, string>;
  requiredFields?: string[];
  supportedFields?: { key: string; label: string; required: boolean }[];
};

export type MappingRow = {
  attribute: string;
  mapsTo: { value: string; label: string } | null;
  isDefault?: boolean;
};

export function buildMappingRowsFromDefaults(
  defaults: PresetDefaultsData,
): MappingRow[] {
  const mapping = defaults.attributeMapping;
  if (!mapping || typeof mapping !== 'object') return [];
  return Object.entries(mapping).map(([key, mapsTo]) => ({
    attribute: key,
    mapsTo: mapsTo ? { value: mapsTo, label: mapsTo } : null,
    isDefault: true,
  }));
}

export function mergeMappingRowsWithDefaults(
  existingRows: MappingRow[],
  defaults: PresetDefaultsData,
): MappingRow[] {
  const mapping = defaults.attributeMapping;
  if (!mapping || typeof mapping !== 'object') return existingRows;

  const defaultMapsToValues = new Set(Object.values(mapping).filter(Boolean));
  const existingMapsTo = new Set(
    existingRows.map((r) => r.mapsTo?.value).filter(Boolean),
  );

  const mergedRows = existingRows.map((row) =>
    row.mapsTo?.value && defaultMapsToValues.has(row.mapsTo.value)
      ? { ...row, isDefault: true }
      : row,
  );

  Object.entries(mapping).forEach(([key, mapsTo]) => {
    if (mapsTo && !existingMapsTo.has(mapsTo)) {
      mergedRows.push({
        attribute: key,
        mapsTo: { value: mapsTo, label: mapsTo },
        isDefault: true,
      });
    }
  });

  return mergedRows;
}
